/**
 * Spec 35, Fachregel 4: die Art einer Zeile als Symbol plus Wort.
 *
 * Das Symbol hängt am Wert (`category.value`), das Wort kommt wörtlich aus
 * `category.label` — der Client führt keine deutsche Artenliste
 * (`no-hardcoded-labels.test.ts`). Ohne Art gilt das Symbol von „Sonstiges".
 */

import { Calculator, ClipboardList, File, FileSignature, FileX, Landmark, Mail, Receipt } from 'lucide-react'
import type { ReactElement } from 'react'

import type { DocumentRow } from '@/features/documents/api'

const ICON_CLASS = 'size-4'

const CATEGORY_ICON: Readonly<Record<string, ReactElement>> = {
  invoice: <Receipt aria-hidden="true" className={ICON_CLASS} />,
  contract: <FileSignature aria-hidden="true" className={ICON_CLASS} />,
  authority: <Landmark aria-hidden="true" className={ICON_CLASS} />,
  statement: <Calculator aria-hidden="true" className={ICON_CLASS} />,
  notice: <FileX aria-hidden="true" className={ICON_CLASS} />,
  protocol: <ClipboardList aria-hidden="true" className={ICON_CLASS} />,
  correspondence: <Mail aria-hidden="true" className={ICON_CLASS} />,
}

const NEUTRAL_ICON = <File aria-hidden="true" className={ICON_CLASS} />

/** Dekoratives Symbol: das Wort steht in `documentKindLine`. „Sonstiges",
 * ohne Art und unbekannte Werte zeigen das neutrale Symbol. */
export function categoryIcon(category: DocumentRow['category']): ReactElement {
  return (category !== null ? CATEGORY_ICON[category.value] : undefined) ?? NEUTRAL_ICON
}

/** „Art · Absender"; nur das Vorhandene, ohne beides `null` (Zeile entfällt). */
export function documentKindLine(document: Pick<DocumentRow, 'category' | 'sender'>): string | null {
  const parts = [document.category?.label, document.sender].filter((part): part is string => part != null && part !== '')
  return parts.length === 0 ? null : parts.join(' · ')
}
